import { render, staticRenderFns } from "./PrismsUserDisableMfaDialog.vue?vue&type=template&id=7d90ab70&"
import script from "./PrismsUserDisableMfaDialog.vue?vue&type=script&lang=js&"
export * from "./PrismsUserDisableMfaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports